// Vendor imports
const Immutable = require('immutable')
// Common imports
const ArticleProfileModalRecord = require('client-v2/common/containers/article-profile/state/modal-record')
const AuthModalRecord = require('client-v2/common/containers/auth-modal/record')
const { keyedReviver } = require('client-v2/common/state/record-reviver')
const EnvRecord = require('client-v2/common/state/env/record')
const RouterRecord = require('client-v2/common/state/router/record')
const UserRecord = require('client-v2/common/state/user/record')
// Entry imports
const DiscoverRecord = require('client-v2/logged-out-landing/containers/discover/record')
const FeaturedCollectionsRecord = require('client-v2/logged-out-landing/containers/featured-collections/record')
const StumbleUponSubmitModalRecord = require('client-v2/logged-out-landing/containers/su-submit-modal/record')
const TopCallToActionRecord = require('client-v2/logged-out-landing/containers/top-call-to-action/record')

class LandingRootRecord extends Immutable.Record({
  // Global common state
  env: null,
  router: null,
  user: null,
  // Common containers
  articleProfileModal: null,
  authModal: null,
  // Entry containers
  discover: new DiscoverRecord(),
  featuredCollections: new FeaturedCollectionsRecord(),
  suSubmitModal: null,
  topCallToAction: new TopCallToActionRecord()
}) {
  // No methods yet
}

LandingRootRecord.reviver = keyedReviver(LandingRootRecord, {
  // Common state records
  env: EnvRecord.reviver,
  router: RouterRecord.reviver,
  user: UserRecord.reviver,
  // Common container records
  articleProfileModal: ArticleProfileModalRecord.reviver,
  authModal: AuthModalRecord.reviver,
  // Entry container records
  discover: DiscoverRecord.reviver,
  featuredCollections: FeaturedCollectionsRecord.reviver,
  suSubmitModal: StumbleUponSubmitModalRecord.reviver,
  topCallToAction: TopCallToActionRecord.reviver
})

module.exports = LandingRootRecord
